import React, { useCallback } from "react";

const ImageWithFallback = ({ src, fallbackSrc, alt, ...props }) => {

  const onError = useCallback((event) => {
    // Note: can be changed to react state update if this comp needs to rerendered

    // If in onError callback we don't have fallbackSrc or the src is already fallbackSrc then we show Generic icon
    const newSrc = (!fallbackSrc || (event.target.src === fallbackSrc) || decodeURIComponent(event.target.src).endsWith(fallbackSrc)) ? "/images/bom-icons/Generic.svg" : fallbackSrc;

    Object.assign(event.target, {
        onerror: null,
        src: newSrc,
        className: `${event.target.className} fallback-image`,
    });

    event.target.removeAttribute("srcset");
    event.target.style.objectFit = "contain"
    
  }, [fallbackSrc])
  

  return (
    <img className="bimmatch-image"
      src={src}
      alt={alt || "image"}
      onError={onError}
      {...props}
    />
  );
};

export default ImageWithFallback;